import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@application/config';
import type {
  ClassScopeMarkField,
  LatenessScopeClass,
  ODataCollection,
} from '../entities/lateness-scope.model';
import type { OfferedClassVacancy } from '../entities/lateness-scope-vacancy.model';

@Injectable({ providedIn: 'root' })
export class LatenessScopeService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(APP_CONFIG).apiUrl;

  public listMarkedClasses(
    academicYearId: string,
    markField: ClassScopeMarkField = 'ApplyLateLimit'
  ): Observable<ODataCollection<LatenessScopeClass>> {
    const params = new HttpParams()
      .set('$filter', `${markField} eq true and AcademicYearId eq ${academicYearId}`)
      .set('$select', 'SchoolClassId,Name,GradeLevelName,ShiftName')
      .set('$orderby', 'Name');

    return this.http.get<ODataCollection<LatenessScopeClass>>(`${this.apiUrl.odata_school_service}/SchoolClass`, {
      params,
      withCredentials: true,
    });
  }

  public countClasses(academicYearId: string): Observable<ODataCollection<LatenessScopeClass>> {
    const params = new HttpParams()
      .set('$filter', `AcademicYearId eq ${academicYearId}`)
      .set('$count', 'true')
      .set('$top', '0');

    return this.http.get<ODataCollection<LatenessScopeClass>>(`${this.apiUrl.odata_school_service}/SchoolClass`, {
      params,
      withCredentials: true,
    });
  }

  public vacancies(academicYearId: string): Observable<OfferedClassVacancy[]> {
    const params = new HttpParams().set('academicYearId', academicYearId);

    return this.http.get<OfferedClassVacancy[]>(`${this.apiUrl.school_service}/OfferedClass/vacancies`, {
      params,
      withCredentials: true,
    });
  }
}
